
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.01 4v12.17l-6.93-5.59L5.332 12l9.918 8 9.919-8-1.748-1.41-6.93 5.58V4h-2.48z","fill":"#108999"}}),_c('path',{attrs:{"stroke":"#108999","stroke-width":"2","d":"M3.617 18v6M27.617 18v6M27.617 23h-24"}})])
          )
        }
      }
    